import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import wallPreviewsAdapter from './wall_previews.adapter';
import actions from './wall_previews.actions';

import type { WallPreview } from '.';
import type { LoadingStatus } from 'types/common_types';

type WallPreviewsInitialState = {
  status: LoadingStatus;
};

const initialState: WallPreviewsInitialState = {
  status: 'idle',
};

const wallPreviews = createSlice({
  name: 'wallPreviews',
  initialState: wallPreviewsAdapter.getInitialState(initialState),
  reducers: {
    updateWallPreview(state, { payload }: PayloadAction<WallPreview>) {
      const update = wallPreviewsAdapter.updateOne(state, { id: payload.id, changes: payload });

      return update;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(actions.saveWallPreview.pending, (state) => {
        return { ...state, status: 'loading' };
      })
      .addCase(actions.saveWallPreview.fulfilled, (state, { payload }) => {
        const update = wallPreviewsAdapter.addOne(state, payload);

        update.status = 'idle';
        return update;
      })
      .addCase(actions.saveWallPreview.rejected, (state) => {
        return { ...state, status: 'error' };
      })
      .addCase(actions.getAll.pending, (state) => {
        return { ...state, status: 'loading' };
      })
      .addCase(actions.getAll.fulfilled, (state, { payload }) => {
        const update = wallPreviewsAdapter.addMany(state, payload);
        update.status = 'idle';
        return update;
      })
      .addCase(actions.getAll.rejected, (state) => {
        // Handle an error, send more details to sentry, etc
        return { ...state, status: 'error' };
      })
      .addCase(actions.destroy.fulfilled, (state, { payload }) => {
        return wallPreviewsAdapter.removeOne(state, payload);
      });
  },
});

export default wallPreviews;
